import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';
import { UserProfile } from './user.model';
import { UserApiError } from './user.errors';
import {
  Organization,
  OrganizationAccesses,
  OrganizationConfig,
} from 'src/app/admin/models/organization.model';

export const SetUserRoles = createAction('[User] Set User Roles', props<{ roles: string[] }>());

export const SetUserName = createAction(
  '[User] Set User Name',
  props<{ familyName: string; givenName: string }>(),
);

export const SetUserId = createAction('[User] Set User ID', props<{ id: string }>());

export const SetUserOrganization = createAction(
  '[User] Set User Organization',
  props<{ id: number; name: string; displayName: string; orgType: string; orgRoles: string[] }>(),
);

export const UpdateUserProfile = createAction(
  '[User] Update User Profile',
  props<{ userProfile: Partial<UserProfile> }>(),
);

export const SetUserApiError = createAction(
  '[User] Set User API Error',
  props<{ error: UserApiError }>(),
);

export const RemoveUserApiError = createAction('[User] Remove User API Error');

export const LoadOrganizationProfile = createAction('[User] Load Organization Profile');

export const SetOrganizationProfile = createAction(
  '[User] Set Organization Profile',
  props<{ organizationProfile: Partial<Organization> }>(),
);

export const UpdateOrganizationProfile = createAction(
  '[User] Update Organization Profile',
  props<{ organizationProfile: Partial<Organization> }>(),
);

export const UpdateOrganizationProfileSucceeded = createAction(
  '[User] Update Organization Profile Succeeded',
  props<{ organizationProfile: Partial<Organization> }>(),
);

export const LoadOrganizationConfig = createAction('[User] Load Organization Config');

export const SetOrganizationConfig = createAction(
  '[User] Set Organization Config',
  props<{ organizationConfig: OrganizationConfig }>(),
);

export const SetOrganizationAccesses = createAction(
  '[User] Set Organization Accesses',
  props<{ organizationAccesses: OrganizationAccesses }>(),
);

export const SwitchOrganizationClicked = createAction(
  '[My Organization Menu] Switch Organization Clicked',
  props<{ organizationId: number }>(),
);
export const SwitchOrganizationSucceeded = createAction(
  '[User Effect] Switch Organization Succeeded',
);

export const UserAuthActions = createActionGroup({
  source: 'User Auth',
  events: {
    'Refresh User Token Succeeded': emptyProps(),
    'Refresh User Token Errored': props<{ error: Error }>(),
  },
});
